module.exports = __webpack_public_path__ + "static/img/12b.d0cdaee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/12b.jpg
// module id = Ucxy
// module chunks = 0